// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const gemGeode = defineModel({
  id: "gem-geode",
  batchId: "future",
  name: "Gem geode",
  tags: ["scenery","gem","geode","low-poly","age-of-mcp","future"],
  summary: "A crystal-lined geode. Cut into gems for jewellery and prestige trade.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.24, 0), color: "#5a5650", position: [-0.18, 0.2, -0.04], rotation: [0.1, 0.5, 0.2], scale: [1, 1.1, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.2, 0), color: "#4c4944", position: [0.18, 0.18, -0.06], rotation: [0.08, 1.4, -0.25], scale: [1, 1.05, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.17, 0), color: "#3a3640", position: [0, 0.2, 0.08], rotation: [0.1, 0.3, 0], scale: [1.1, 1, 0.7] },
      { geometry: new THREE.ConeGeometry(0.04, 0.18, 5), color: "#9b6cd0", position: [-0.04, 0.34, 0.12], rotation: [0.3, 0, 0.1] },
      { geometry: new THREE.ConeGeometry(0.035, 0.15, 5), color: "#b98fe6", position: [0.06, 0.32, 0.14], rotation: [0.35, 0, -0.2] },
      { geometry: new THREE.ConeGeometry(0.03, 0.13, 5), color: "#9b6cd0", position: [-0.1, 0.28, 0.1], rotation: [0.4, 0, 0.3] },
      { geometry: new THREE.ConeGeometry(0.035, 0.16, 5), color: "#4fc2a4", position: [0.02, 0.3, 0.16], rotation: [0.45, 0, 0.05] },
      { geometry: new THREE.ConeGeometry(0.028, 0.12, 5), color: "#76e0c4", position: [0.12, 0.26, 0.12], rotation: [0.4, 0, -0.3] },
      { geometry: new THREE.ConeGeometry(0.026, 0.1, 5), color: "#b98fe6", position: [-0.14, 0.24, 0.14], rotation: [0.5, 0, 0.4] },
      { geometry: new THREE.ConeGeometry(0.024, 0.09, 5), color: "#4fc2a4", position: [0.16, 0.22, 0.16], rotation: [0.5, 0, -0.4] },
      { geometry: new THREE.TetrahedronGeometry(0.07, 0), color: "#9b6cd0", position: [0.08, 0.05, 0.18], rotation: [0.3, 0.6, 0.2], scale: [1, 1.2, 0.9] },
      { geometry: new THREE.TetrahedronGeometry(0.05, 0), color: "#76e0c4", position: [-0.12, 0.04, 0.16], rotation: [0.4, 1.2, 0.3] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#4c4944", position: [0.19, 0.04, -0.1], rotation: [0.2, 0.8, 0.2], scale: [1.1, 0.7, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#5a5650", position: [-0.18, 0.04, -0.08], rotation: [0.3, 1, 0.2] },
    ],
  animations: [],
});
